import React, { useRef } from "react";
import "./invoice.scss";
import logo from "../../assets/images/logos/logo.png";
import html2pdf from "html2pdf.js";
import { toWords } from "number-to-words";

const InvoiceReceipt = ({ studentData = {}, calculated = {} }) => {
  const printAreaRef = useRef();

  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-IN");

  const invoiceNumber = `JNANI-${today.getFullYear()}-${Date.now()
    .toString()
    .slice(-5)}`;

  const formatCurrency = (num) =>
    num
      ? `₹${Number(num).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
      : "₹0.00";

  const generatePDF = () => {
    const element = printAreaRef.current;

    const options = {
      margin: 10,
      filename: `${invoiceNumber}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().from(element).set(options).save();
  };

  return (
    <div>
      <div ref={printAreaRef} className="invoice-container p-4 bg-white">
        {/* HEADER */}
        <div className="text-center mb-4">
          <img src={logo} alt="IAS Jnani Logo" className="invoice-logo mb-2" />
          <h2 style={{ color: "#00306E" }}>Jnani Educational Pvt. Ltd.</h2>
          <p className="mb-0">
            <b>CIN: U85500KA2025PTC202970</b>
          </p>
          <p className="mb-0">
            <b>GSTIN: YOUR-GSTIN-HERE</b>
          </p>
        </div>

        {/* INVOICE INFO */}
        <div className="d-flex justify-content-between mb-3">
          <div>
            <strong>Invoice No:</strong> {invoiceNumber}
            <br />
            <strong>Date:</strong> {formattedDate}
          </div>

          <div className="text-end">
            <strong>To:</strong>
            <br />
            {studentData.name}
            <br />
            Email: {studentData.email}
            <br />
            Mobile: {studentData.mobile}
            <br />
            <strong>Student ID:</strong> {studentData.studentId}
          </div>
        </div>

        {/* TABLE */}
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Description</th>
              <th className="text-end">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{calculated.courseName}</td>
              <td className="text-end">
                {formatCurrency(calculated.baseAmount)}
              </td>
            </tr>

            {calculated.gstAmount > 0 && (
              <>
                <tr>
                  <td>SGST @ 9%</td>
                  <td className="text-end">
                    {formatCurrency(calculated.gstAmount / 2)}
                  </td>
                </tr>
                <tr>
                  <td>CGST @ 9%</td>
                  <td className="text-end">
                    {formatCurrency(calculated.gstAmount / 2)}
                  </td>
                </tr>
              </>
            )}

            <tr className="fw-bold">
              <td>Total</td>
              <td className="text-end">{formatCurrency(calculated.total)}</td>
            </tr>

            {studentData.discount > 0 && (
              <tr>
                <td>Discount</td>
                <td className="text-end text-danger">
                  - {formatCurrency(studentData.discount)}
                </td>
              </tr>
            )}

            <tr>
              <td>Amount Received</td>
              <td className="text-end">
                {formatCurrency(studentData.amountReceived)}
              </td>
            </tr>

            <tr className="fw-bold">
              <td>Amount Due</td>
              <td className="text-end">{formatCurrency(calculated.due)}</td>
            </tr>
          </tbody>
        </table>

        {/* FOOTER INFO */}
        <div className="mt-4">
          <p>
            <strong>Amount in Words:</strong>{" "}
            {calculated.finalAmount
              ? `${toWords(Math.round(calculated.finalAmount))} rupees only`
              : ""}
          </p>

          <p>
            <strong>Payment Mode:</strong> {studentData.paymentMode}
          </p>

          <ul className="small mt-3">
            <li>
              <i>Fees once paid are non-refundable.</i>
            </li>
            <li>
              <i>
                This is a computer-generated invoice and does not require a
                physical signature.
              </i>
            </li>
          </ul>
        </div>

        <hr className="mt-5" />

        <div className="text-center small text-muted mt-3">
          <p>Email: contact@iasjnani.com | Phone: +91-9482936712</p>
          <p>Website: www.iasjnani.com</p>
        </div>
      </div>

      <div className="text-center mt-3">
        <button onClick={generatePDF} className="btn btn-primary px-4">
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default InvoiceReceipt;
